"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var Grid_1 = require("@lsg/components/lib/components/atoms/Grid/Grid");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var Paragraph_1 = require("@lsg/components/lib/components/atoms/Paragraph/Paragraph");

var react_components_1 = require("@lws/react-components");

exports.TeaserComponent = function (_a) {
  var data = _a.data;
  var title = data.text('title');
  var label = data.text('label');
  var description = data.longText('description');
  var ctaText = data.text('ctaText');
  var image = data.asset('image');
  var linkUrl = data.field('link').text('url');
  return react_1["default"].createElement(components_1.Grid, null, react_1["default"].createElement(GridRow_1.GridRow, {
    verticalAlign: Grid_1.VerticalAlign.MIDDLE,
    theme: components_1.Themes.DARK,
    gap: Grid_1.Spacing.SECTION
  }, react_1["default"].createElement(GridColumn_1.GridColumn, {
    md: 4
  }, react_1["default"].createElement(react_components_1.LsgPicture, {
    fluidData: image.fluid(),
    alt: image.title()
  })), react_1["default"].createElement(GridColumn_1.GridColumn, {
    md: 8
  }, label && label.length > 0 && react_1["default"].createElement(components_1.Paragraph, {
    size: Paragraph_1.Sizes.HELPER
  }, label), react_1["default"].createElement(components_1.H2, null, title), react_1["default"].createElement(components_1.Paragraph, null, description), react_1["default"].createElement(components_1.Button, {
    to: linkUrl
  }, ctaText))));
};